module.exports = __webpack_public_path__ + "static/media/gb-eng.e18b270f.svg";